export type DriverRoadDistanceState =
    | { status: 'idle' }
    | { status: 'loading' }
    | { status: 'success'; roadDistanceMi: number; driverLocationFixAt: string }
    | { status: 'error'; message: string }

export const IDLE_DRIVER_ROAD_DISTANCE: DriverRoadDistanceState = { status: 'idle' }
